import { inputId } from '../constants/inputId'
import { createTestId } from './createTestId'

export const inputTestIds = (testId: string) => {
  return {
    input: createTestId(testId, inputId.input),
    minus: createTestId(testId, inputId.minus),
    plus: createTestId(testId, inputId.plus),
    label: createTestId(testId, inputId.label),
    error: createTestId(testId, inputId.error),
    tip: createTestId(testId, inputId.tip)
  }
}
